import React, { useCallback, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import { MultipleFilterBar } from '../../../components';
import {
  getAllQueryData, getQueryData, getQueryFilter, stringifyQuery,
} from '../../../utility/helpers';
import {
  Filter, FilterMap, ItemList, ListParams,
} from '../../../types/main';
import { Article } from '../../../types/items';
import { selectProject } from '../../../store/modules/projects/selectors';
import { getArticleListRequest } from '../../../store/modules/articles/actions';

type Props = {
  data: ItemList<Article>;
};

const makeFilters = ({ data } : Props): FilterMap[] => {
  if (data) {
    const projectId = getQueryFilter('project_id', data.filters.active);

    return [
      {
        key: 'project_id',
        label: 'All',
        value: projectId ? projectId.value : '',
        required: true,
      },
      {
        key: 'media_type_id',
        label: 'Photos',
        value: 1,
      },
      {
        key: 'media_type_id',
        label: 'Videos',
        value: 2,
      },
      {
        key: 'media_type_id',
        label: 'Audio',
        value: 3,
      },
      {
        key: 'media_type_id',
        label: 'Documents',
        value: 4,
      },
      {
        key: 'media_type_id',
        label: 'Other',
        value: 0,
      },
    ];
  }
  return [];
};

const FilterBarMedia = ({ data }: Props) => {
  const dispatch = useDispatch();
  const queryData = getQueryData();
  const currentProject = useSelector(selectProject);

  let actualFilters = data ? data.filters : queryData.filters;
  if (queryData.filters.active.length > 0) {
    actualFilters.active = queryData.filters.active;
  }
  const commonFilters = actualFilters.active.filter((f) => f.key !== 'search');

  const [activeFilters, setActiveFilters] = useState<Filter[]>(commonFilters);

  useEffect(() => {
    (async () => {
      const commonProjectId = commonFilters.find((item) => item.key === 'project_id');
      const activeProjectId = activeFilters.find((item) => item.key === 'project_id');
      if (commonProjectId && activeProjectId && commonProjectId.value !== activeProjectId.value) {
        setActiveFilters(commonFilters);
      }
    })();
  }, [commonFilters, activeFilters, setActiveFilters]);

  const changeActiveFilters = useCallback((activeFiltersValue: Filter[]) => {
    setActiveFilters(activeFiltersValue);

    if (currentProject.data) {
      const queryData = getAllQueryData();

      const params: ListParams = {
        page: 0,
        sort_dir: queryData.sort_dir || 'DESC',
        page_size: Number(queryData.page_size) || 5,
        filter: {
          project_id: currentProject.data.id,
          is_media: 1,
        },
      };

      const changedFilter = activeFiltersValue.filter((item) => item.key === 'media_type_id').map((item) => item.value);

      if (changedFilter.length > 0) {
        params.filter = { ...params.filter, media_type_id: changedFilter[0] };
      }
      dispatch(push({ search: stringifyQuery(params) }));
      dispatch(getArticleListRequest(params));
    }
  }, [dispatch, setActiveFilters, currentProject]);


  return (
    <Grid item xs={12}>
      <MultipleFilterBar
        onChange={changeActiveFilters}
        available={actualFilters.available}
        active={activeFilters}
        filters={makeFilters({ data })}
      />
    </Grid>
  );
};

export default FilterBarMedia;
